module.exports = __webpack_public_path__ + "img/girl-with-laptop.6525b51f.png";